export type UploadStatus =
  | 'init'
  | 'presign'
  | 'ready'
  | 'start'
  | 'uploading'
  | 'complete'
  | 'error'
  | 'cancel';

export type PresignedUrl = {
  storageKey: string;
  signedUrl: string;
  expiration: number;
};

export interface FileUploadState {
  file?: File;
  presignedUrl?: PresignedUrl;
  status?: UploadStatus;
  progress: number;
  response?: Response;
  error?: any;
}

export enum InputAcceptType {
  Images = 'image/*,.jpeg,.jpg,.png,.gif',
  Video = 'video/mp4,.mp4,.m4v,.mov,video/x-m4v',
  Zip = '.zip',
  Documents = '.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  Presentation = '.ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation',
  PDF = '.pdf,application/pdf'
}
